const eventPathHelper = {subscription: 'subscription', course: 'courses'};

export function processMessageLink(
    link: string | undefined,
    eid: string | undefined,
    pid: string | undefined,
    eventType: string | undefined,
    currentPath: string
): string | undefined {
    if(!link) {
        return link;
    }

    const packagePageMatch = link.match(/[?&]packagePage=([^&]+)/);
    const isAccountLinkWithPackagePage = link.startsWith('/p/pid') && packagePageMatch;
    
    if(isAccountLinkWithPackagePage && eid && currentPath.startsWith('/e/')) {
        const packagePageValue = packagePageMatch[1];
        return `${currentPath}?packagePage=${packagePageValue}`;
    }

    let processedLink = link;

    if(eid) {
        processedLink = processedLink
            .replace(/\/e\/eid(\/|$)/g, `/e/${eid}$1`)
            .replace(/\/eventType\//g, `/${eventPathHelper[eventType] || 'tickets'}/`);
    }

    if(pid) {
        processedLink = processedLink.replace(/\/p\/pid(\/|$)/g, `/p/${pid}$1`);
    }

    return processedLink;
}
